import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Services from '../components/Services';
import About from '../components/About';
import HowToSchema from '../components/HowToSchema';
// import Testimonials from '../components/Testimonials'; // Commented out until we have enough testimonials
import FAQ from '../components/FAQ';
import FAQSchema from '../components/FAQSchema';
import InternalLinks from '../components/InternalLinks';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import SEOHelmet from '../components/SEOHelmet';
import LocalBusinessSchema from '../components/LocalBusinessSchema';
import OrganizationSchema from '../components/OrganizationSchema';
import PerformanceOptimizer from '../components/PerformanceOptimizer';

const HomePage = () => {
  return (
    <div>
      <SEOHelmet 
        title="Attorney Service | Legal Document Specialist California | Process Server & Court Filing"
        description="Premier attorney service & legal document specialist in California. High-volume process serving, e-filing, court filing, skip tracing for law firms. Same-day service available. Licensed & bonded. Request a quote online."
        keywords="attorney service California, legal document specialist, process server law firms, high volume process serving, California court filing, e-filing services, attorney support services, legal document services California, process serving attorneys"
        canonical="/"
      />
      <LocalBusinessSchema 
        pageType="homepage"
        specificServices={["LegalService", "ProfessionalService", "LocalBusiness"]}
      />
      <Header />
      <main id="main-content">
        <Hero />
        <Services />
        <About />
        <HowToSchema />
        {/* <Testimonials /> */} {/* Hidden until we have enough testimonials to publish */}
        <FAQ />
        <InternalLinks currentPage="/" />
        <Contact />
      </main>
      <Footer />
      <OrganizationSchema />
      <FAQSchema />
      <PerformanceOptimizer />
    </div>
  );
};

export default HomePage;